__turbopack_context__.v({
  "catalogContent": "styles-module___KXGLa__catalogContent",
  "catalogWrap": "styles-module___KXGLa__catalogWrap",
});
